export const CircularProgress = ({
  value,
  total,
  stroke = 6,
  radius = 36
}: {
  value: number;
  total: number;
  radius?: number;
  stroke?: number;
}) => {
  const normalizedRadius = radius - stroke * 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const percentage = value / total * 100;
  const strokeDashoffset = circumference - percentage / 100 * circumference;
  const commonProps = {
    cx: radius,
    cy: radius,
    r: normalizedRadius,
    strokeWidth: stroke,
    fill: 'transparent'
  };
  return <div className="relative flex items-center justify-center" data-sentry-component="CircularProgress" data-sentry-source-file="circular-progress.tsx">
      <svg viewBox="0 0 69 69" className="-rotate-90 h-12 md:h-14 w-12 md:w-14" data-sentry-element="svg" data-sentry-source-file="circular-progress.tsx">
        <circle stroke="#e3e2e3" {...commonProps} data-sentry-element="circle" data-sentry-source-file="circular-progress.tsx" />
        <circle stroke="#143176" strokeDasharray={circumference + ' ' + circumference} style={{
        strokeDashoffset
      }} strokeLinecap="butt" {...commonProps} data-sentry-element="circle" data-sentry-source-file="circular-progress.tsx" />
      </svg>
      <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-xs sm:text-sm font-semibold text-primary text-center">
        {value}/{total}
      </span>
    </div>;
};